import { useMemo } from 'react';

import { getIsOwnerFromClaim } from 'api/authentication/store/selectors';
import { useAccessTokenStore } from 'api/authentication/store/useAccessTokenStore';
import { useUserPermissions } from 'api/subscriptions/hooks/useUserPermissions';
import isArray from 'lodash/isArray';

export const useUserHasScope = (scope: Scopes | Scopes[]) => {
  const { data: scopes = [], isPending } = useUserPermissions();

  const result = useMemo(() => {
    // Return null if the scopes are still pending
    if (isPending) {
      return null;
    }

    const hasAccess = !isArray(scope) ? scopes.includes(scope) : scope.some((req) => scopes.includes(req));

    return hasAccess;
  }, [isPending, scope, scopes]);

  return result;
};

export const useUserIsOwner = () => {
  return useAccessTokenStore(getIsOwnerFromClaim);
};

export type Scopes =
  | 'subscription:owner'
  | 'invite:owner'
  | 'user_feature:owner'
  | 'billing:viewer'
  | 'template:creator'
  | 'template:viewer-by'
  | 'projectteams:owner'
  | 'project:owner'
  | 'project_settings:owner'
  | 'project_access:owner'
  | 'import:owner'
  | 'import:runner'
  | 'project:edit-by'
  | 'project_documents:owner'
  | 'integrations:owner'
  | 'integrations:assigner';

export type Features =
  | 'SubscriptionAdministrator'
  | 'TemplateAdministrator'
  | 'ProjectTeamsAdministrator'
  | 'ProjectAdministrator'
  | 'ProjectDataImporter'
  | 'ProjectContributor'
  | 'IntegrationsAdministrator';
